export default __webpack_public_path__ + "static/media/plasma.e7f74178.mp3";